import React, { SetStateAction, startTransition } from 'react';
import CustomButton from '../CustomButton';
import { ReactComponent as DoneBox } from 'assets/quote/doneBox.svg'
import { useNavigate } from 'react-router-dom';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    refresh: () => void
}

const QuoteDone = ({ isOpen, setIsOpen, refresh }: IConfrimDialog) => {
    const navigate = useNavigate();

    const cancel = () => {
        refresh();
        setIsOpen(false);
    }

    const goProcess = () => {
        startTransition(() => {
            navigate("/transport/list");
        });
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className="flex justify-center items-center">
                            <DoneBox />
                        </div>
                        <div className='flex flex-col gap-3'>
                            <p className='text-2xl'>견적 확정이 완료 되었습니다.</p>
                            <p className='text-[#9D9EB7]'>세부 내역은 <span className='text-primary'>진행현황</span>  에서 확인이 가능합니다</p>
                        </div>
                        <div className="flex justify-center gap-4">
                            <CustomButton title={'닫기'} onClick={cancel} className='hover:!bg-white !border-[#9D9EB7] w-[200px] !h-15 !text-[#9D9EB7]' />
                            <CustomButton title={'진행현황 바로가기'} onClick={goProcess} className={'w-[200px] !h-15 bg-primary'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteDone;